import React, { useEffect, useState } from "react";
import QRCode from "qrcode";

import {
  QR_DARK_COLOR,
  QR_DEFAULT_SIZE,
  QR_ERROR_CORRECTION_LEVEL,
  QR_LIGHT_COLOR,
  QRCodeProps,
} from "./shared";

export * from "./shared";

const QRCodeRenderer = ({ url, size = QR_DEFAULT_SIZE }: QRCodeProps) => {
  const [qrDataUrl, setQrDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const generateQRCode = async () => {
      try {

        const dataUrl = await QRCode.toDataURL(url, {
          width: size,
          margin: 0,
          errorCorrectionLevel: QR_ERROR_CORRECTION_LEVEL,
          color: {
            dark: QR_DARK_COLOR,
            light: QR_LIGHT_COLOR,
          },
        });

        if (!cancelled) {
          setQrDataUrl(dataUrl);
        }
      } catch (error) {
        console.error("Failed to generate QR code:", error);
      }
    };

    generateQRCode();

    return () => {
      cancelled = true;
    };
  }, [url, size]);

  if (!qrDataUrl) {
    return (
      <div
        style={{
          width: size,
          height: size,
          backgroundColor: "#fff",
        }}
      />
    );
  }

  return (
    <img
      src={qrDataUrl}
      alt="QR Code"
      width={size}
      height={size}
      style={{
        display: "block",
      }}
    />
  );
};

export default QRCodeRenderer;
